import { render, staticRenderFns } from "./newGenerationRule.vue?vue&type=template&id=96f3396e&scoped=true&"
import script from "./newGenerationRule.vue?vue&type=script&lang=js&"
export * from "./newGenerationRule.vue?vue&type=script&lang=js&"
import style0 from "./newGenerationRule.vue?vue&type=style&index=0&id=96f3396e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96f3396e",
  null
  
)

export default component.exports